import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TextArea from 'components/form-components/TextArea';
import HyperLink from './HyperLink';
import ValueFormatting from './ValueFormatting';
import WidgetStyling from './WidgetStyling';

const AdvanceTab = ({ values, errors, touched, dashboardOptions, pageLookup, handleChange }) => {
  const { t } = useTranslation();

  return (
    <div className='d-flex flex-column gap-3'>
      <div>
        <label className='theme-text-black-1 theme-size-1_1 theme-font-inter-medium'>
          {t('field_tooltip')}
        </label>
        <TextArea
          name='tooltip'
          classes='w-auto'
          value={values.tooltip}
          error={errors.tooltip}
          touched={touched.tooltip}
          handleChange={handleChange}
          placeholder='text_tooltip_description'
          rows={2}
        />
        <span className='mt-1 d-block'>{t('text_dashboard_widget_tooltip_max_char_limit')}</span>
      </div>

      {'linkedPageId' in values && (
        <HyperLink
          value={values.linkedPageId}
          dashboardOptions={dashboardOptions}
          pageLookup={pageLookup}
          onChange={handleChange}
        />
      )}

      {'backgroundColor' in values && <WidgetStyling values={values} handleChange={handleChange} />}

      {'formattingFontSize' in values && (
        <ValueFormatting values={values} handleChange={handleChange} />
      )}
    </div>
  );
};

AdvanceTab.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  dashboardOptions: PropTypes.object.isRequired,
  pageLookup: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default AdvanceTab;
